// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"fc22c056","160":"fc22c056","212":"7ac263e6","521":"fc22c056"}[chunkId] + ".chunk.css";
};